// extracted by mini-css-extract-plugin
export default {"root__btn":"style-module__root__btn___GSwqv"};
    if(module.hot) {
      // 1697460468304
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  